export default __webpack_public_path__ + "static/media/Button Set 2.196f22be.svg";